// FASE 05 — item 13/PO 2026-08-26: "apresentar uma caixa de texto para que visualmente o
// usuário saiba que os campos são para edição".
//
// O DataGrid v5 só vira editor com duplo clique, o que escondia a edição. Aqui a célula é
// sempre um campo: o usuário clica e digita. O valor é confirmado no blur (ou Enter), para
// não disparar uma gravação a cada tecla.

import React, { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";

interface CelulaPrecoProps {
  valor: number;
  desabilitado: boolean;
  onConfirmar: (novoValor: number) => void;
}

// Plano 28/10/2026, Frente D: 4 casas decimais em todas as tabelas de preços (pedido do TI de 27/10).
const paraTexto = (valor: number): string =>
  Number.isFinite(valor) ? valor.toFixed(4).replace(".", ",") : "0,0000";

const paraNumero = (texto: string): number | null => {
  const limpo = (texto || "").replace(/\s/g, "").replace(/\./g, "").replace(",", ".");
  if (limpo === "") return 0;
  const numero = Number(limpo);
  return Number.isFinite(numero) && numero >= 0 ? numero : null;
};

export const CelulaPreco: React.FC<CelulaPrecoProps> = ({ valor, desabilitado, onConfirmar }) => {
  const [texto, setTexto] = useState(() => paraTexto(valor));
  // Plano 28/10/2026, Frente D: só confirma o que o usuário DIGITOU. Antes, entrar e sair do
  // campo comparava o texto arredondado com o valor gravado e registrava uma "alteração"
  // (ex.: $ Item 0,0545 → 0,05 × 48 = 2,40 na embalagem de 2,6138).
  const [digitado, setDigitado] = useState(false);

  // Recarga da página (troca de filtro, salvar, paginação) precisa refletir no campo.
  useEffect(() => {
    setTexto(paraTexto(valor));
    setDigitado(false);
  }, [valor]);

  const confirmar = () => {
    if (!digitado) {
      setTexto(paraTexto(valor));
      return;
    }
    setDigitado(false);

    const numero = paraNumero(texto);

    if (numero === null) {
      setTexto(paraTexto(valor));
      return;
    }

    setTexto(paraTexto(numero));
    if (numero !== valor) onConfirmar(numero);
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      value={texto}
      disabled={desabilitado}
      onChange={(e) => {
        setTexto(e.target.value);
        setDigitado(true);
      }}
      onBlur={confirmar}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === "Enter") (e.target as HTMLInputElement).blur();
      }}
      onClick={(e) => e.stopPropagation()}
      InputProps={{
        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
      }}
      inputProps={{ style: { textAlign: "right", padding: "6px 4px" } }}
      sx={{ width: "100%", backgroundColor: desabilitado ? "transparent" : "#fff" }}
    />
  );
};
